export const exportToCSV = (data: Blob, fileName: string): void => {
  const csvFile = new Blob([data], { type: 'text/csv' })
  const downloadLink = document.createElement('a')
  downloadLink.setAttribute('download', fileName)
  downloadLink.setAttribute('href', window.URL.createObjectURL(csvFile))
  downloadLink.click()
  downloadLink.remove()
}

export const downloadFromUrl = (url: string): void => {
  const downloadLink = document.createElement('a')
  downloadLink.setAttribute('href', url)
  downloadLink.setAttribute('download', '')
  downloadLink.setAttribute('target', '_blank')
  downloadLink.click()
  downloadLink.remove()
}
